import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "preview"]
  static values = { active: { type: String, default: "feed" }, live: Boolean }

  connect() {
    this.showTab(this.activeValue)
    if (this.liveValue) this.enter()
  }

  switchTab(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.activeValue = tab
    this.showTab(tab)
  }

  showTab(name) {
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === name
      tab.classList.toggle("text-tavern-gold", isActive)
      tab.classList.toggle("border-tavern-gold", isActive)
      tab.classList.toggle("text-tavern-muted", !isActive)
      tab.classList.toggle("border-transparent", !isActive)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== name)
    })
  }

  enter() {
    document.body.classList.add("focus-mode")
    this.element.classList.add("play-surface-active")
    this.previewTargets.forEach(el => el.classList.add("hidden"))
  }

  exit() {
    document.body.classList.remove("focus-mode")
    this.element.classList.remove("play-surface-active")
    this.previewTargets.forEach(el => el.classList.remove("hidden"))
  }
}
